/* eslint-disable no-console */
var logger = {
    warn: function (message) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(message);
        }
    },
};

export { logger };
